import { useParams, useSearchParams } from "react-router-dom";
import { getBasePathWithTrailingSlash } from "../../common/env.ts";
import styles from "./EmbedMain.module.scss";

const demoText =
  "This is a demo of home in an iframe with some external UI around it";

export default function EmbedMain() {
  const urlParams = useParams();
  const [searchParams] = useSearchParams();

  const clonedParams = new URLSearchParams(searchParams);
  const embedHost = clonedParams.get("host") ?? window.location.host;
  clonedParams.delete("host");

  const queryString = clonedParams.toString();
  const passThroughSearchParams = queryString ? "?" + queryString : "";

  return (
    <>
      <div className={styles.header}>{demoText}</div>
      <div className={styles.content}>
        <div className={styles.sidebar}>{demoText}</div>
        <iframe
          title={demoText}
          src={
            `https://${embedHost}` +
            getBasePathWithTrailingSlash() +
            (urlParams["*"] ?? "") +
            passThroughSearchParams
          }
          className={styles.iframe}
        />
      </div>
    </>
  );
}
